export default __webpack_public_path__ + "./images/banner-cta.svg";